export const mapDifferenceStyle = (difference: number) => {
  if (difference === undefined) {
    return {
      style: "style__up",
      value: "NEW"
    }
  }

  if (difference > 0) {
    return {
      style: "style__up",
      value: "+" + difference
    }
  }

  if (difference < 0) {
    return {
      style: "style__down",
      value: difference.toString().replace("-", "–")
    }
  }

  return {
    style: "style__neutral",
    value: difference
  }
}